import React from 'react';
import {Typography} from '@mui/material';
import {GridActionsCellItem, GridActionsColDef, GridRowParams} from '@mui/x-data-grid-pro';

import {ColumnProps} from '@utils/table/columnTypes.table';
import {Array} from '@utils/extensions/array.extension';
import {Colors} from '@constants/colors.constants';

interface TextWithActionColumnProps extends ColumnProps {
  actionLabel: (row: any) => any;
  handleClick?: (row: any) => void;
  handleMouseOver?: (row: any, event) => void;
  handleMouseOut?: (row: any, event) => void;
  textButton?: boolean;
}

export const COLUMN_TYPE_TEXT_WITH_ACTION = (props: TextWithActionColumnProps): GridActionsColDef => ({
  cellClassName: (params) => Array.mapNotNull([props.color, props.cellClassName?.(params)])?.join(' ') ?? '',
  field: props.field ?? '',
  headerName: props.label,
  minWidth: props.minWidth ?? 50,
  sortable: props.sortable ?? false,
  align: props.textButton ? undefined : 'center',
  type: 'actions',
  getActions: (params: GridRowParams) => {
    const text = props.actionLabel(params.row);

    return [(
      <GridActionsCellItem onMouseEnter={(event) => {
        props.handleMouseOver?.(params.row, event);
      }} onMouseLeave={(event) => {
        props.handleMouseOut?.(params.row, event);
      }} style={text != null && text != '' ? {
        border: `1px solid ${Colors.primary}`,
        borderRadius: props.textButton ? 4 : undefined,
        height: 25,
        width: props.textButton ? 'auto' : 25,
      } : {
        display: 'none',
      }} icon={(
        <Typography fontSize="14px" color={props.color ? Colors[props.color] : undefined}>
          {text}
        </Typography>
      )} onClick={() => {
        props.handleClick?.(params.row);
      }} label="" showInMenu={false}/>
    )];
  },
  valueGetter: props.valueGetter,
  valueFormatter: props.valueFormatter,
  width: props.width ?? 150,
});
